// extracted by mini-css-extract-plugin
export var assigneeBadge = "_k2-0";
export var assigneeDetails = "_k2-1";
export var assigneeInfo = "_k2-2";
export var dropdownContainer = "_k2-4";
export var dropdownImage = "_k2-5";
export var editAssigneeInfo = "_k2-3";
export var editAssigneeModalContainer = "_k2-6";
export var hidden = "_k2-8";
export var input = "_k2-7";